<template>
    <p-modal v-if="display" @onClickBG="onClickBG">
        <div slot="content">
            <div class="title">
                尚有任務未評價
            </div>
            <div class="order" v-for="order in orders" :key="order.id">
                <div class="location">
                    {{ order.location }}
                </div>
                <div class="info">
                    <div class="date">
                        #{{ order.id }}  {{ order.date | date }}
                    </div>
                    <div class="next" v-if="orders.length > 1" @click.stop="goToOrderScore(order)">
                        評價
                        <img src="@/assets/img/next-green.svg">
                    </div>
                </div>
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                先不要
            </div>
            <div class="confirm button" @click="goToOrderScore(orders[0])" v-if="orders.length === 1">
                前往評價
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import moment from "moment";
    import { rated } from '../../../apis';

    export default {
        name: 'UnratedOrderModal',
        components: {
            'p-modal': Modal,
        },
        data() {
            return {
                display: false,
                orders: [],
                readId: 0,
            };
        },
        methods: {
            onClickBG() {
              this.display = false;
            },
            onConfirm() {
                this.display = false;
                this.setRated();
                this.$emit('onConfirm');
            },
            onCancel() {
                this.display = false;
                this.setRated();
                this.$emit('onCancel');
            },
            setRated() {
               if (this.readId <= 0) {
                   return;
               }

               rated(this.readId);
            },
            show(orders, read = 0) {
                this.display = true;
                this.orders = orders;
                this.readId = read;
            },
            goToOrderScore(order) {
                this.display = false;
                this.$router.push({
                    name: 'score',
                    params: {
                        id: order.id,
                    }
                });
            },
        },
        filters: {
            date(date) {
                return moment(date).format('MM/DD hh:mm');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .order {
        text-align: left;
        padding: 15px;
        color: #4A4A4A;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 20px;
        cursor: default;
        user-select: none;

        .info {
            margin-top: 5px;
            display: flex;
            justify-content: space-between;
            color: #9B9B9B;
            font-size: 12px;
            letter-spacing: 0;
            line-height: 17px;

            .next {
                color: #339933;
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }

    .buttons {
        display: flex;

        .button {
            flex: 1;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: #339933;
            }

            &:nth-child(even) {
                border-left: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
